module.exports = __webpack_public_path__ + "static/media/logo-txt.a7abed67.png";